import { Box, CircularProgress, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

const Root = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.background.default,
}));

const Card = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  width: '100%',
  maxWidth: 420,
  borderRadius: (theme.shape.borderRadius as number) * 2,
}));

const Header = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  textAlign: 'center',
}));

export const AuthLayout = (): JSX.Element => (
  <Root>
    <Card elevation={2}>
      <Header>
        <Typography variant="h5" sx={{ fontWeight: 700 }} color="primary">
          PTNetSuite
        </Typography>
      </Header>
      <Suspense fallback={<Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}><CircularProgress /></Box>}>
        <Outlet />
      </Suspense>
    </Card>
  </Root>
);
